import { ALL_CHART_TYPES } from "constants/chart.constants";
import { createMergeWithDefaults } from "entities/utils";
import { CumTimeChartRequestType, CumTimeChartSettings } from "types";

import { BASE_RATE_CHART_SETTINGS, BASE_RATE_REQUEST } from "./baseRateRequest";

export const DEFAULT_CUM_TIME_CHART_SETTINGS: Partial<CumTimeChartSettings> = {
  ...BASE_RATE_CHART_SETTINGS,
  chartType: ALL_CHART_TYPES.CumTime.id
};

export const DEFAULT_CUM_TIME_REQUEST: Partial<CumTimeChartRequestType> = {
  ...BASE_RATE_REQUEST,
  chartSetting: DEFAULT_CUM_TIME_CHART_SETTINGS as CumTimeChartSettings
};

export const generateCumTimeRequestBody = createMergeWithDefaults(
  DEFAULT_CUM_TIME_REQUEST
);
